import template from './building-developer.jade';
import validation from '../../../services/validation';

export default angular
  .module('cian.addForm.buildingDeveloper', [])
  .directive('cianAfAboutBuildingBuildingDeveloper', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller: [
      'deviceService',
      function (deviceService) {
        this.isMobile = deviceService.isMobile;
        this.validation = validation(this.form, 'building.developer', {});
      },
    ],
    controllerAs: 'buildingDeveloper',
    template,
  })).name;
